<template>
  <div class="comercializadora-grid-container">
    <div class="comercializadora-container">
      <div class="comercializadora-logo-container">
        <img v-if="model?.ImagenB64 != ''" :src="model?.ImagenB64" class="comercializadora-logo" />
      </div>
    </div>

    <div class="comercializadora-info">
      <div>
        <h5>
          {{ model?.Nombre }}
        </h5>
      </div>
      <div>
        {{ model?.DireccionContacto }}
      </div>
      <div>
        {{ model?.NombreContacto }}
      </div>
    </div>

    <div class="comercializadora-contact">
      <div>
        {{ model?.EmailContacto }}
      </div>
      <div>
        {{ model?.TelContacto }}
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { type DetailEmpresaServiciosEnergiaModel, type DetailEmpresaServiciosAguaModel, TipoEmpresaServiciosEnum } from '@api/api';
import { useApi } from '@api/integration';

const props = defineProps({
  idEmpresaServicios: String,
  tipoServicio: String
});

const model = ref<DetailEmpresaServiciosEnergiaModel | DetailEmpresaServiciosAguaModel | null>();
const api = useApi();

onMounted(async () => {

  let empresaServiciosDetail: DetailEmpresaServiciosEnergiaModel | DetailEmpresaServiciosAguaModel | null = null;

  switch (props.tipoServicio!.toUpperCase()) {
    case TipoEmpresaServiciosEnum.Energia:
      empresaServiciosDetail = await api.callStandardApi("getEmpresaServiciosEnergiaById", {showLoading: false}, props.idEmpresaServicios!);
      break;
    case TipoEmpresaServiciosEnum.Agua:
      empresaServiciosDetail = await api.callStandardApi("getEmpresaServiciosAguaById", {showLoading: false}, props.idEmpresaServicios!);
      break;
  }

  model.value = empresaServiciosDetail;
});

</script>


<style lang="scss" scoped>


.comercializadora-grid-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  gap: 20px;
  align-items: center;
  box-sizing: border-box;
  max-width: 50%;
  margin-bottom: 15px;
}

.comercializadora-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.comercializadora-logo-container {
  border: 1px solid var(--border-default-default);
  background-color: var(--background-surface-default);
  min-height: 90px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 5px;
}

.comercializadora-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.comercializadora-info,
.comercializadora-contact {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 5px;
}

.comercializadora-contact {
  border-left: 2px solid var(--border-default-default);
  padding-left: 20px;
}
</style>